module.exports = "/assets/ece9bb35c77ae40e8fd402494e2193fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YW.png
// module id = 2045
// module chunks = 0